import moment from 'moment'
import config from '@/config'

export default {
  /**
   * Return delivery date
   *
   * @param {String} deliverAtStart
   * @returns {String}
   */
  getDeliveryDate (deliverAtStart) {
    return deliverAtStart ? moment(deliverAtStart, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') : ''
  },

  /**
   * Return delivery slot
   *
   * @param {String} deliverAtStart
   * @param {String} deliverAtEnd
   * @returns {String}
   */
  getDeliverySlot (deliverAtStart, deliverAtEnd) {
    if (!deliverAtStart) {
      return ''
    }

    const startTime = moment(deliverAtStart, 'YYYY-MM-DD HH:mm:ss')
    const endTime = moment(deliverAtEnd, 'YYYY-MM-DD HH:mm:ss')

    // if date/time starts on 00 minute, just return hour part
    const start = startTime.minutes() === 0 ? startTime.format('HH') : startTime.format('HH:mm')
    const end = endTime.minutes() === 0 ? endTime.format('HH') : endTime.format('HH:mm')

    return `${start} - ${end}`
  },

  /**
   * Return info about moved order delivery slot
   *
   * @param {Object} order
   * @returns {String}
   */
  getOrderDeliverMovedAtInfo (order) {
    if (!order.timestamps.delivery_moved_at) {
      return ''
    }

    const timestamp = moment(order.timestamps.delivery_moved_at, 'YYYY-MM-DD HH:mm:ss')

    return this.$t('orders.info.deliver_moved', { date: timestamp.format('YYYY-MM-DD'), time: timestamp.format('HH:mm') })
  },

  /**
   * Return info about last order edit
   *
   * @param {Object} order
   * @returns {String}
   */
  getOrderLastEditedAtInfo (order) {
    if (!order.timestamps.last_edited_at) {
      return ''
    }

    const timestamp = moment(order.timestamps.last_edited_at, 'YYYY-MM-DD HH:mm:ss')

    return this.$t('orders.info.last_edited', { date: timestamp.format('YYYY-MM-DD'), time: timestamp.format('HH:mm') })
  },

  /**
   * Open new tab with customer location marked on google maps
   *
   * @param {Object} customer
   */
  showOnGoogleMaps (customer) {
    const addressString = (customer.address + ' ' + customer.street_number).trim()
      + ', ' + customer.postal_code + ' ' + customer.province + ' ' + customer.city

    window.open(config.google_map_search_url + addressString, '_blank');
  },

  /**
   * Check if is a Click And Collect order
   * 
   * @param {Object} order 
   * @returns {boolean}
   */
  isClickAndCollectOrder (order) {
    return order.fulfillment_type === 4
  },
}
